import { render } from "./PlanoComp.vue?vue&type=template&id=d0595f20&scoped=true"
import script from "./PlanoComp.vue?vue&type=script&lang=js"
export * from "./PlanoComp.vue?vue&type=script&lang=js"

import "./PlanoComp.vue?vue&type=style&index=0&id=d0595f20&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0595f20"]])

export default __exports__